import React, {useEffect, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend, ChartData, Point,
} from "chart.js";
import { Line } from "react-chartjs-2";


export type GraphData = {
    date: Date,
    score: number
}

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


type GraphType = {
    data: GraphData[],
    label: string,
    reverseY?: boolean,
}

export const Graph: React.FC<GraphType> = ({
    data,
    label,
    reverseY = false,
}: GraphType) => {
    const {t} = useTranslation();

    const [graphData, setGraphData] = React.useState<ChartData<"line", (number | Point | null)[], unknown> | null>(null);

    const options = useMemo(() => ({
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            x: {
                display: false,
            },
            y: {
                display: false,
                reverse: reverseY,
            },
        },
    }), []);

    useEffect(() => {
        const graphData = {
            labels: data.map((d) => t("global.date-dd-mm-yyyy", {date: d.date})),
            datasets: [
                {
                    data: data.map((d) => d.score),
                    label: label,
                    borderColor: "rgb(255, 255, 255)",
                }
            ],
        };

        setGraphData(graphData);
    }, []);
    
    return (
        <>
            {graphData !== null && <Line options={options} data={graphData} />}
        </>
    )
}
